import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  HomeParkingSiteCard,
  SitePublicProfileDetail,
  mapHomeParkingSiteCard,
  mapSitePublicProfileDetail,
} from '../../../models/site-public-profile.model';

@Injectable({
  providedIn: 'root',
})
export class ApiSitePublicService {
  private readonly apiUrl = `${environment.apiPrivateUrl}`;

  constructor(private http: HttpClient) {}

  /*############################################# API #################################################*/

  /**
   * ลานบน Home — online + published · รูป base64 · มี publicRef
   * GET /Cityparking/getHomeParkingSites
   */
  getHomeParkingSites(): Observable<HomeParkingSiteCard[]> {
    return this.http
      .get<any[]>(`${this.apiUrl}/Cityparking/getHomeParkingSites`)
      .pipe(
        map((rows) =>
          Array.isArray(rows) ? rows.map(mapHomeParkingSiteCard) : [],
        ),
      );
  }

  /**
   * รายละเอียดลานสาธารณะ · opaque ref (encode จาก profile id)
   * GET /Cityparking/getPublicParkingSiteDetail?ref=
   */
  getPublicParkingSiteDetail(publicRef: string): Observable<SitePublicProfileDetail> {
    const params = new HttpParams().set('ref', publicRef);
    return this.http
      .get<any>(`${this.apiUrl}/Cityparking/getPublicParkingSiteDetail`, { params })
      .pipe(map(mapSitePublicProfileDetail));
  }
}
